import moment from "moment-timezone";

export default function Hour(props) {
    const onHourChooseHandler = () => {
        // From mentee's timezone to UTC : hour = HH:mm
        // let selectedDate = moment(props.selectedDate).tz(
        //     props.selectedTimezone,
        // );
        // selectedDate.hours(props.hour.split(":")[0]);
        // selectedDate.minutes(props.hour.split(":")[1]);
        // selectedDate.seconds(0);
        // selectedDate.milliseconds(0);
        // console.log(props.hour);
        // Convert to UTC
        // console.log("utc", selectedDate.utc().format("HH:mm"));
        // console.log(
        //     "mentee",
        //     selectedDate.tz(props.selectedTimezone).format("HH:mm"),
        // );
        // console.log(
        //     "mentor",
        //     selectedDate.tz(props.mentor.timezone).format("HH:mm"),
        // );
        // props.setSelectedHour(selectedDate.format("HH:mm"));
        // props.setSelectedHourUTC(selectedDate.utc().format("HH:mm"));
        props.setSelectedSlot(props.slot);
    };

    const isSelected =
        props.selectedSlot &&
        props.selectedSlot.start.format("HH:mm") ==
            props.slot.start.format("HH:mm");

    return (
        <button
            type="button"
            onClick={onHourChooseHandler}
            className={`w-full rounded-lg border flex justify-center items-center px-3 py-2.5 text-sm font-semibold tabular-nums transition-all ${
                isSelected
                    ? "bg-gray-900 text-white border-gray-900 dark:bg-white dark:text-grayDark-900 dark:border-white"
                    : "border-gray-200 dark:border-borderDark text-gray-900 dark:text-white hover:border-gray-900 dark:hover:border-white"
            }`}
        >
            {props.slot.start.format(
                props.timeFormat === "12h" ? "h:mm A" : "HH:mm",
            )}
        </button>
    );
}
